/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PostFranchiseFormInput = {|
  budget: string,
  comments?: ?string,
  conversion: string,
  email: string,
  experienced: string,
  location: string,
  name: string,
  postcode?: ?string,
  suburb?: ?string,
  telephone: string,
  timeframe: string,
|};
export type PostFranchiseFormMutationVariables = {|
  input: PostFranchiseFormInput
|};
export type PostFranchiseFormMutationResponse = {|
  +postFranchiseForm: ?{|
    +result: ?boolean
  |}
|};
export type PostFranchiseFormMutation = {|
  variables: PostFranchiseFormMutationVariables,
  response: PostFranchiseFormMutationResponse,
|};
*/


/*
mutation PostFranchiseFormMutation(
  $input: PostFranchiseFormInput!
) {
  postFranchiseForm(input: $input) {
    result
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PostFranchiseFormPayload",
    "kind": "LinkedField",
    "name": "postFranchiseForm",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostFranchiseFormMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostFranchiseFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ed7c53f9cd0680948fece4e27d4f34f0",
    "id": null,
    "metadata": {},
    "name": "PostFranchiseFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostFranchiseFormMutation(\n  $input: PostFranchiseFormInput!\n) {\n  postFranchiseForm(input: $input) {\n    result\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a9172b208f8ca02e8415ce238eadd95e';

module.exports = node;
